module.exports = __webpack_public_path__ + "img/43.5.COD.01cdec09.png";